import React from 'react';
import { Grid } from '@material-ui/core';
import TruckFilesUpload from './TruckFilesUpload';

const TruckDetailCard = ({
  truckersData,
  selectedTrucker,
  activeRole,
  userDetails,
  featureFlagFiles,
  refetch,
}) => {
  return (
    // <div style={truckDetailsCardStyle}>
    <Grid container spacing={3}>
      {truckersData.map(truck => (
        <TruckFilesUpload
          selectedTrucker={selectedTrucker}
          activeRole={activeRole}
          userDetails={userDetails}
          truck={truck}
          featureFlagFiles={featureFlagFiles}
          refetch={refetch}
        />
      ))}
    </Grid>
    // </div>
  );
};

export default TruckDetailCard;
